import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=22bd7b58"
import script from "./manifest.vue?vue&type=script&lang=js"
export * from "./manifest.vue?vue&type=script&lang=js"
import style0 from "./manifest.vue?vue&type=style&index=0&id=22bd7b58&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports